import React, { useEffect, useRef, useState } from "react";
import MobileIcon from "../../../assets/icons/ABHA-icons/mobile-icon";
import axios from "axios";
import errorToast from "../../helper-components/error-toast";
import { url } from "../../../redux/config";
import successToast from "../../helper-components/success-toast";
import AddButton from "../../buttons/button";
import { handleShowErrorToast } from "../../helper-components/helper-function";
import InputField from "../../forms/input-field";
import LeftArrowIcon from "../../../assets/icons/ABHA-icons/left-arrow-icon";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { useFormikContext } from "formik";
import { Upload, X, CheckCircle, AlertCircle, Cloud } from "lucide-react";
import moment from "moment";
import UploadIcon from "../../../assets/icons/ABHA-icons/upload-icon";
import TickIcon2 from "../../../assets/icons/ABHA-icons/tick2-icon";
import ErrorIcon from "../../../assets/icons/ABHA-icons/error-icon";

function DrivingAddress({
  txnId,
  adhaarNo,
  adhaarAccessToken,
  setTxnId,
  message,
  setmessage,
  setMethod,
  setStatus,
  setPosition,
  tokenExpiresIn,
  closeModal,
  setDrivingSuccessData,
}) {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [submitted, setSubmitted] = useState(false);
  const [base64Data, setBase64Data] = useState("");
  const [loading, setLoading] = useState(false);

  const initialValues = {
    mobile: "",
    licence: "",
    firstName: "",
    middleName: "",
    lastName: "",
    date: "",
    gender: "",
    address: "",
    pincode: "",
    district: "",
    state: "",
    drivingLicenseFront: "",
    drivingLicenseBack: "",
    consent: false,
  };
  const inputRefs = useRef([]);

  const handleInputChange = (index, value) => {
    if (value.length > 1) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("Please enter a valid 10 digit Mobile number")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),

    licence: Yup.string()
      .required("Licence number is required")
      .matches(
        /^[A-Za-z0-9]+$/,
        "Licence must contain only letters and numbers"
      ),

    // firstName: Yup.string()
    //   .required("First name is required")
    //   .matches(/^[A-Za-z]+$/, "First name must contain only letters"),

    // middleName: Yup.string()
    //   .nullable()
    //   .matches(/^[A-Za-z]*$/, "Middle name must contain only letters"),

    // lastName: Yup.string()
    //   .required("Last name is required")
    //   .matches(/^[A-Za-z]+$/, "Last name must contain only letters"),
    firstName: Yup.string()
      .required("First name is required")
      .matches(
        /^[A-Za-z ]+$/,
        "First name must contain only letters and spaces"
      )
      .trim(),

    middleName: Yup.string()
      .nullable()
      .matches(
        /^[A-Za-z ]*$/,
        "Middle name must contain only letters and spaces"
      )
      .trim(),

    lastName: Yup.string()
      .required("Last name is required")
      .matches(/^[A-Za-z ]+$/, "Last name must contain only letters and spaces")
      .trim(),

    date: Yup.date()
      .required("Date is required")
      .max(new Date(), "Date cannot be in the future"),

    gender: Yup.string().required("Gender is required"),

    address: Yup.string().required("Address is required"),

    pincode: Yup.string()
      .required("Pincode is required")
      .matches(/^\d{6}$/, "Pincode must be 6 digits"),

    district: Yup.string().required("District is required"),

    state: Yup.string().required("State is required"),

    drivingLicenseFront: Yup.string().required(
      "Driving license front image is required"
    ),

    consent: Yup.boolean().oneOf([true], "Consent is required"),
  });

  const sendOtpWithAadhaar = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/abha-create-enrollment-via-dl-create-enrollment-number`,
        {
          txnId: txnId,
          documentType: "DRIVING_LICENCE",
          documentId: values.licence,
          firstName: values.firstName,
          middleName: values.middleName,
          lastName: values.lastName,
          dob: moment(values.date).format("YYYY-MM-DD"),
          gender: values.gender[0],
          address: values.address,
          state: values.state,
          district: values.district,
          pinCode: values.pincode,
          frontSidePhoto: removeBase64Prefix(values.drivingLicenseFront),
          backSidePhoto: removeBase64Prefix(values.drivingLicenseBack),
          accessToken: adhaarAccessToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setLoading(false);

      console.log("Response:", response);
      successToast("OTP is verified");
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      setmessage(response?.data?.data?.abdmResponse?.message);
      console.log(
        "_____________",
        response?.data?.data?.abdmResponse?.enrolProfile
      );
      console.log("..............", response);
      setDrivingSuccessData(response?.data?.data?.abdmResponse?.enrolProfile);
      setStatus("Confirmation");
      setPosition(4);

      //   setLoading(false);
      //   setPopUp(true);

      return response.data;
    } catch (error) {
      errorToast(error.response?.data || error.message);
      console.error(
        "Error verifying OTP:",
        error.response?.data || error.message
      );
      setLoading(false);
      // throw error;
    }
  };
  const today = new Date().toISOString().split("T")[0];
  function removeBase64Prefix(base64String) {
    const prefix = "data:image/png;base64,";
    if (base64String.startsWith(prefix)) {
      return base64String.slice(prefix.length);
    }
    return base64String;
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={sendOtpWithAadhaar}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form>
          {console.log("======================", values)}
          <div className="mt-6 flex flex-col gap-6">
            <div
              onClick={() => {
                setStatus("OTP Verification");
                setPosition(2);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              className="flex flex-row gap-2 items-center cursor-pointer "
            >
              <LeftArrowIcon />
              <label
                className={`
                cursor-pointer text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fw)] whitespace-nowrap`}
              >
                Back
              </label>
            </div>
            <div className="flex flex-col  gap-4">
              <label
                className={`
                 text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
              >
                Verify Driving Licence for ABHA number
              </label>
            </div>
            <div className="flex flex-col gap-0">
              <div className="flex flex-row gap-4 w-full ">
                <InputField
                  //   errMsgContainerClass="hidden"
                  maxLength={10}
                  isRequired={true}
                  type="number"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`mobile`}
                  placeholder="Enter Mobile Number"
                  label="Mobile Number"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                />
                <InputField
                  isRequired={true}
                  //   errMsgContainerClass="hidden"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`licence`}
                  placeholder="Enter Driving Licence number"
                  label="Driving Licence number"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                />
              </div>
              <div className="flex flex-row gap-4 w-full ">
                <InputField
                  isRequired={true}
                  //   errMsgContainerClass="hidden"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`firstName`}
                  placeholder="Enter First name"
                  label="First name"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                  onKeyDown={() => {}}
                />
                <InputField
                  //   errMsgContainerClass="hidden"
                  onKeyDown={() => {}}
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`middleName`}
                  placeholder="Enter Middle name"
                  label="Middle name"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                />
                <InputField
                  isRequired={true}
                  //   errMsgContainerClass="hidden"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`lastName`}
                  placeholder="Enter Last name"
                  label="last name"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                  onKeyDown={() => {}}
                />
              </div>
              <div className="flex flex-row gap-4 w-[20%] ">
                <InputField
                  isRequired={true}
                  type="date"
                  //   errMsgContainerClass="hidden"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`date`}
                  placeholder="Select Your Date Of Birth"
                  label="Date Of Birth"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                  max={today}
                />
                <div className="flex flex-col gap-5 mb-2">
                  <label
                    className={`flex flex-row gap-2 text-[var(--alert-management-label-color)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-fw)] whitespace-nowrap`}
                  >
                    Gender{" "}
                    {<span className="text-[var(--dashboard-danger)]">*</span>}
                  </label>
                  <div className="flex flex-row gap-6">
                    <label
                      className={`flex flex-row gap-2 text-[var(--alert-management-label-color)] text-[length:var(--abha-method-label-fs)] mb-2 font-[var(--abha-method-label-fw)] w-full`}
                    >
                      <Field type="radio" name="gender" value="Male" />
                      Male
                    </label>
                    <label
                      className={`flex flex-row gap-2 text-[var(--alert-management-label-color)] text-[length:var(--abha-method-label-fs)] mb-2 font-[var(--abha-method-label-fw)] w-full`}
                    >
                      <Field type="radio" name="gender" value="Female" />
                      Female
                    </label>
                    <label
                      className={`flex flex-row gap-2 text-[var(--alert-management-label-color)] text-[length:var(--abha-method-label-fs)] mb-2 font-[var(--abha-method-label-fw)] w-full`}
                    >
                      <Field type="radio" name="gender" value="Transgender" />
                      Transgender
                    </label>
                  </div>
                </div>
              </div>

              <div className="flex flex-row gap-4 w-full ">
                <InputField
                  onKeyDown={() => {}}
                  isRequired={true}
                  //   errMsgContainerClass="hidden"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`address`}
                  placeholder="Enter Your Full Address"
                  label="Address"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                />
              </div>
              <div className="flex flex-row gap-4 w-full ">
                <InputField
                  isRequired={true}
                  //   errMsgContainerClass="hidden"
                  maxLength={6}
                  type="number"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`pincode`}
                  placeholder="Enter Pincode"
                  label="Pincode"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                />
                <InputField
                  isRequired={true}
                  //   errMsgContainerClass="hidden"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`district`}
                  placeholder="Enter District"
                  label="District"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                />
                <InputField
                  isRequired={true}
                  //   errMsgContainerClass="hidden"
                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                  parentClass="flex  flex-col gap-2 w-full align-end "
                  name={`state`}
                  placeholder="Enter State"
                  label="State"
                  defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                  containerClass="w-full h-min"
                />
              </div>
            </div>

            <div className="flex flex-row gap-3 w-full ">
              <div className="w-full">
                <FileUploadField
                  name="drivingLicenseFront"
                  label="Driving Licence (Frontside)"
                  acceptedTypes="image/*"
                  maxSizeKB={150}
                  required={true}
                />
              </div>
              <div className="w-full">
                <FileUploadField
                  name="drivingLicenseBack"
                  label="Driving Licence (Backside)"
                  acceptedTypes="image/*"
                  maxSizeKB={150}
                  required={true}
                />
              </div>
            </div>
            <div className="p-[10px]  flex gap-3 border border-[var(--abha-nav-bg)] rounded-lg">
              {/* <input type="checkbox" className="mb-auto mt-2" /> */}
              <Field type="checkbox" name="consent" className="mb-auto mt-1" />
              <label
                className={`text-[var(--abha-nav-fg)] leading-[23px]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
              >
                I agree to share my Aadhaar details for ABHA creation as per
                ABDM guidelines. This information will be used solely for the
                purpose of creating your ABHA number and will be handled in
                accordance with data protection regulations.
              </label>
            </div>
            {/* <div className="w-full flex justify-end">
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                // onclkFn={() => handleShowErrorToast(errors)}
                text={<span>Next</span>}
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="submit"
              />
            </div> */}
            <div
              style={{
                bottom: "0",
              }}
              className="flex flex-row gap-3 justify-end  sticky bg-white py-4 mt-auto "
            >
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                onclkFn={() => closeModal()}
                text={<span>Cancel</span>}
                className="
                flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
                 cursor-pointer
                text-[var(--primary-button-bg-color)]
                border border-[var(--primary-button-bg-color)]
                text-[length:var(--primary-button-create-fs)]
                font-[var(--primary-button-font-weight)]
                "
                type="button"
              />
              <AddButton
                prefixIcon={false}
                loading={loading}
                onclkFn={() => handleShowErrorToast(errors)}
                text={<span>Next</span>}
                className="
                flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
                bg-[var(--primary-button-bg-color)] cursor-pointer
                text-[var(--primary-button-fg-color)]
                border border-[var(--primary-button-bg-color)]
                hover:bg-[var(--primary-button-hover-color)]
                text-[length:var(--primary-button-create-fs)]
                font-[var(--primary-button-font-weight)]
                "
                type="submit"
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

const FileUploadField = ({
  name,
  label,
  acceptedTypes = "image/*",
  maxSizeKB = 150,
  required = false,
}) => {
  const { setFieldValue, values, errors, touched, setFieldError } =
    useFormikContext();
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("initial"); // 'initial', 'success', 'error'
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const fileInputRef = useRef(null);

  const formatFileSize = (bytes) => {
    return Math.round(bytes / 1024) + "KB";
  };
  // min-h-[140px]

  const validateFile = (file) => {
    if (file.size > maxSizeKB * 1024) {
      return `File size must be less than ${maxSizeKB}KB`;
    }

    const allowedTypes = acceptedTypes.split(",").map((type) => type.trim());
    const isValidType = allowedTypes.some((type) => {
      if (type === "image/*") return file.type.startsWith("image/");
      return file.type === type;
    });

    if (!isValidType) {
      return errorToast(`File type not supported. Allowed: ${acceptedTypes}`);
    }

    return null;
  };

  const handleFileSelection = async (file) => {
    const validationError = validateFile(file);

    if (validationError) {
      setUploadStatus("error");
      setFieldError(name, validationError);
      return;
    }

    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result;
        setFieldValue(name, base64);
        setUploadStatus("success");
        setFileName(file.name);
        setFileSize(formatFileSize(file.size));
        setFieldError(name, undefined);
      };
      reader.onerror = () => {
        setUploadStatus("error");
        setFieldError(name, "Failed to read file");
      };
      reader.readAsDataURL(file);
    } catch (error) {
      setUploadStatus("error");
      setFieldError(name, "Failed to process file");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      handleFileSelection(files[0]);
    }
  };

  const handleFileInputChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      handleFileSelection(files[0]);
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  const handleUploadAgain = () => {
    setUploadStatus("initial");
    setFileName("");
    setFileSize("");
    setFieldValue(name, "");
    setFieldError(name, undefined);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click(); // Open file picker
    }
  };

  const hasError = touched[name] && errors[name];
  const hasValue = values[name];

  const getBorderColor = () => {
    if (uploadStatus === "error" || hasError)
      return "border-[var(--error-color)]";
    if (uploadStatus === "success") return "border-[var(--success-color)]";
    if (isDragOver) return "border-[var(--primary)]";
    return "border-[var(--list-pagination-select-border)]";
  };

  const getBackgroundColor = () => {
    if (uploadStatus === "error" || hasError) return "bg-[var(--abha-card-bg)]";
    if (uploadStatus === "success") return "bg-[var(--status-badge-green-bg)]";
    if (isDragOver) return "bg-[var(--status-badge-green-bg)]";
    return "bg-gray-50";
  };

  return (
    <div className="w-full">
      {label && (
        <label
          className={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] mb-9 font-[var(--alert-management-sub-title-fw)] w-full`}

          // className={`text-[length:var(--abha-method-label-fs] font-[var(--abha-method-fw)] whitespace-nowrap mb-2`}
        >
          {label}{" "}
          {required && (
            <span className="text-[var(--dashboard-danger)]">*</span>
          )}
        </label>
      )}
      <div>{}</div>
      <div
        className={`relative border-2  rounded-lg p-6 transition-all duration-200 ${getBorderColor()} ${getBackgroundColor()}`}
        onDrop={handleDrop}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragOver(true);
        }}
        onDragLeave={() => setIsDragOver(false)}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept={acceptedTypes}
          onChange={handleFileInputChange}
          className="hidden"
        />

        <div className="text-center mt-2">
          {uploadStatus === "error" || hasError ? (
            <div
              onClick={handleBrowseClick}
              className="flex flex-col items-center justify-center gap-2 cursor-pointer"
            >
              <ErrorIcon />
              <label
                className={`text-[var(--dashboard-danger)] 
                 text-[length:var(--abha-method-label-fs] font-[var(--abha-method-fw)] whitespace-nowrap cursor-pointer`}
              >
                Failed To Upload
              </label>
              <label
                className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap cursor-pointer`}
              >
                {fileName && `${fileName} (${fileSize})`}
              </label>
              <label
                className={`text-[var(--primary)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-fw)] whitespace-nowrap cursor-pointer`}
              >
                Upload Again
              </label>
            </div>
          ) : uploadStatus === "success" ? (
            <div
              onClick={handleBrowseClick}
              className="flex flex-col items-center justify-center gap-2 cursor-pointer"
            >
              <TickIcon2 />
              <label
                className={`text-[var(--success-color)] 
                 text-[length:var(--abha-method-label-fs] font-[var(--abha-method-fw)] whitespace-nowrap cursor-pointer`}
              >
                Frontside uploaded successfully
              </label>
              <label
                className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap cursor-pointer`}
              >
                {fileName} ({fileSize})
              </label>

              <label
                className={`text-[var(--primary)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-fw)] whitespace-nowrap cursor-pointer`}
              >
                Upload
              </label>
            </div>
          ) : (
            <div
              onClick={handleBrowseClick}
              className="flex flex-col items-center justify-center gap-2 cursor-pointer"
            >
              <UploadIcon />

              <label
                className={`text-[var(--primary)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-fw)] whitespace-nowrap cursor-pointer`}
              >
                Click To Browse
              </label>

              <label
                className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap cursor-pointer`}
              >
                PNG, JPG, JPEG up to {maxSizeKB}KB
              </label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DrivingAddress;
